import { useCallback, useRef } from 'react';
import { useObserveTableElementRef } from '../../../virtualization/hooks/useObserveTableElementRef';
import { COLUMN } from '../../../virtualization/types/observerTypes';
import ContentComponentInner from '../../../resizing/components/ContentComponentInner';
import { useDraggingWrapperStyle } from '../../../resizing/components/contentComponentStyles';
import { withItemDragAndDrop } from './withItemDragAndDrop';

// Props for the external API (what gets passed to ContentComponent)

// Props for the internal component (after withItemDragAndDrop wrapping)
import { jsx as _jsx } from "react/jsx-runtime";
// FIXME: A lot of this content component code
// is duplicated in various places, should be consolidated
// to separate the react-dnd integration bits from the core content component.
export function ContentComponentComponent({
  connectDragSource,
  connectDropTarget,
  isDragging,
  arrowsNode,
  children,
  columnIndex,
  columnName,
  columnNamespace,
  connectDragPreview: __connectDragPreview,
  draggedLeft,
  draggedRight,
  handleResize,
  onResizeEnd,
  originalWidth,
  reorderable,
  resizable,
  reordering: __reordering
}) {
  const initialXRef = useRef(0);
  const handleObserveRef = useObserveTableElementRef();
  const handleMouseDown = useCallback(initiatingEvent => {
    initialXRef.current = initiatingEvent.clientX;

    // Prevent the initiating event from sorting or dragging
    initiatingEvent.preventDefault();
    const handleMouseMove = ({
      clientX
    }) => handleResize(originalWidth + (clientX - initialXRef.current));
    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', event => {
      // Prevent the terminating event from sorting
      event.preventDefault();
      document.removeEventListener('mousemove', handleMouseMove);
      onResizeEnd();
    }, {
      once: true
    });
  }, [handleResize, onResizeEnd, originalWidth]);
  const handleClick = useCallback(event => {
    if (resizable) {
      event.preventDefault();
      event.stopPropagation();
    }
  }, [resizable]);
  const wrapperStyle = useDraggingWrapperStyle(isDragging);

  // Combined ref for drag source, drop target, and observer
  const combinedRef = useCallback(node => {
    connectDragSource === null || connectDragSource === void 0 || connectDragSource(node);
    connectDropTarget === null || connectDropTarget === void 0 || connectDropTarget(node);
    handleObserveRef(node);
  }, [connectDragSource, connectDropTarget, handleObserveRef]);
  return /*#__PURE__*/_jsx("div", Object.assign({
    ref: combinedRef,
    style: wrapperStyle,
    "data-observer-type": COLUMN,
    "data-observer-id": columnIndex
  }, reorderable && {
    'data-test-id': `drag-drop-${columnNamespace}-${columnName}`
  }, {
    children: /*#__PURE__*/_jsx(ContentComponentInner, {
      arrowsNode: arrowsNode,
      columnName: columnName,
      columnNamespace: columnNamespace,
      draggedLeft: draggedLeft,
      draggedRight: draggedRight,
      isDragging: isDragging,
      onClick: handleClick,
      onMouseDown: handleMouseDown,
      resizable: resizable,
      children: children
    })
  }));
}
const WrappedContentComponent = withItemDragAndDrop(ContentComponentComponent);
export function ContentComponent(props) {
  return /*#__PURE__*/_jsx(WrappedContentComponent, Object.assign({}, props));
}